import { ObjectValidation } from '../../../../../utils/component-validations';
import Super from '../../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class SpdsActionButtonDropdownTrigger extends Super {
  arguments = [new ObjectValidation({ required: ['button'] })];
  baseClass = 'spds-action-button-dropdown-trigger';
  classesToMapToArgs = ['disabled', 'open'];
  styles = styles;

  <template>
    <@button
      @disabled={{@disabled}}
      @fitContent={{true}}
      @size={{@size}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-haspopup="menu"
      class={{this.classes}}
      data-test-spds-action-button-dropdown-trigger
      ...attributes
    >
      {{#if @icon}}
        {{svgJar
          @icon
          class="spds-action-button-dropdown-trigger-icon"
          data-test-spds-action-button-trigger-icon=""
        }}
      {{/if}}
      {{yield}}
      {{svgJar "dropdown-caret" class="spds-action-button-dropdown-trigger-caret"}}
    </@button>
  </template>
}
